import {render} from './ToastMessage';

export const showRequestErrorToast = () => {
    render(document.getElementById('request-error-toast-message'));
};

export const showResponseErrorToast = event => {
    if (event.detail.xhr.status === 413) {
        render(document.getElementById('request-too-large-toast-message'));

        return;
    }

    if (event.detail.xhr.status < 400) {
        return;
    }

    showRequestErrorToast();
};

export const showBoostedErrorPage = event => {
    if (!event.detail.boosted || event.detail.xhr.status < 400) {
        return;
    }

    event.detail.isError = false;

    if (event.detail.requestConfig.verb !== 'get') {
        event.detail.shouldSwap = true;

        return;
    }

    event.detail.shouldSwap = false;
    window.location.assign(event.detail.pathInfo.finalRequestPath);
};
